/**
 * AI Analyst copy: the history sidebar, reports, compare and memory dialog.
 * Ported verbatim from VentaHub; wired under `aiAnalyst` in `en.ts`.
 */
export const aiAnalystHistory = {
  sidebar: {
    newChat: 'New chat',
    memory: 'Memory',
    memoryTooltip: 'What the analyst remembers',
    chats: 'Chats',
    reports: 'Reports',
    search: 'Search conversations',
    filterByStore: 'Filter by store',
    allStores: 'All stores',
    selectSeveral: 'Select several',
    doneSelecting: 'Done selecting',
    selectConversations: 'Select conversations',
    selected: '{{count}} selected',
    delete: 'Delete',
    loading: 'Loading conversations',
    noMatches: 'No conversations match.',
    empty: 'Your conversations will appear here.',
    newConversation: 'New conversation',
    selectRow: 'Select {{title}}',
    selectUntitled: 'Select conversation',
    options: 'Options for {{title}}',
    optionsUntitled: 'Options for conversation',
    answerInProgress: 'Answer in progress',
    pinned: 'Pinned',
    filters: 'Filters',
    loadMore: 'Load more',
    rename: 'Rename',
    pin: 'Pin',
    unpin: 'Unpin',
    tags: 'Tags…',
  },
  rename: {
    title: 'Rename conversation',
    label: 'Title',
  },
  tags: {
    title: 'Tags',
    label: 'Tags, separated by commas',
    placeholder: 'weekly, ads',
  },
  deleteOne: {
    title: 'Delete this conversation?',
    body: '“{{title}}” will be removed from your history.',
  },
  deleteMany: {
    title_one: 'Delete {{count}} conversation?',
    title_other: 'Delete {{count}} conversations?',
    body: 'They will be removed from your history.',
  },
  cancel: 'Cancel',
  save: 'Save',
  delete: 'Delete',
  reports: {
    twoPicked: 'Two picked',
    tickTwo: 'Tick two to compare',
    compare: 'Compare',
    empty:
      'Save a snapshot with the bookmark under it, and it appears here for later and for comparing.',
    meta: '{{period}} · saved {{when}}',
    pick: 'Pick {{title}}',
    delete: 'Delete {{title}}',
    deleteTooltip: 'Delete report',
    deleting: 'Deleting {{title}}',
    loading: 'Loading reports',
    range: '{{from}} to {{to}}',
    openEnd: '…',
  },
  report: {
    fallbackTitle: 'Report',
    openConversation: 'Open conversation',
    done: 'Done',
    loading: 'Loading report',
    heading: 'Business health snapshot',
    insights: 'Insights ({{total}})',
    confidence: 'Confidence: {{level}}',
    impact: 'Impact:',
    doNext: 'Do next:',
  },
  compare: {
    title: 'Compare snapshots',
    notMentioned: 'Not mentioned',
    close: 'Close',
    loading: 'Loading reports',
  },
  memory: {
    title: 'What the analyst remembers',
    intro:
      'These apply to every question, such as "our fiscal week starts on Monday" or "always report in AED". Company memories apply to everyone in your company; only people who can edit the AI Analyst can add or remove them.',
    company: 'Company',
    justMe: 'Just me',
    loading: 'Loading…',
    nothing: 'Nothing yet.',
    forget: 'Forget "{{text}}"',
    forgetTooltip: 'Forget this',
    forgetting: 'Forgetting "{{text}}"',
    remember: 'Remember…',
    placeholder: 'e.g. Our hero SKUs are ABC-1, ABC-2',
    for: 'For',
    add: 'Add',
    adding: 'Adding…',
    failed: "That didn't work. Try again.",
    done: 'Done',
  },
} as const
